<template lang="html">
  <div class="us">
    <common-header></common-header>
    <div class="imgContainer">
    	<div>
    		<img src="../../../assets/img/aboutUsKv.png" />
    	</div>
    </div>
    <div class="usContainer">
    	<div class="usTab">关于我们
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">关于我们</div>
    		<div class="eng-title">about us</div>
    		<div class="abstract">关于君弘：君弘财富俱乐部依托国泰君安证券雄厚的研究力量和扎实的服务基础，为会员提供多达80余项的行情交易、资讯、咨询、理财顾问等方面的服务。</div>
    		<div class="content">
    			<div class="text-container">
    				<img src='../../../assets/img/us-1.png' />
    				<div class="text-title">君子之道，弘泽天下</div>
    				<div class="text-content">君弘财富俱乐部是由国泰君安证券倾注十年专业智慧，精心打造的中国证券服务第一俱乐部品牌。依托国泰君安证券雄厚的研究实力与十年的证券服务经验积累，君弘财富俱乐部为您提供更周全的尊荣理财服务，与每一位会员一起，同创恢弘未来，共悦非凡人生！</div>
    			</div>
    			<div class="text-container">
    				<img src='../../../assets/img/us-2.png' />
    				<div class="text-title">君子之交，弘毅宽厚</div>
    				<div class="text-content">君弘财富俱乐部洞悉每一位会员的投资需求，集聚全公司的尖端技术和专业人才力量，倾力关注会员的投资状况和资金安全，与每一位会员一起，理性投资，共享成功。</div>
    			</div>
    			<div class="text-container">
    				<img src='../../../assets/img/us-3.png' />
    				<div class="text-title">君子之交，以诚为鉴</div>
    				<div class="text-content">君弘财富俱乐部长期开展形式多样、轻松高雅的中高端会员活动，免费为会员搭建交流沟通的平台，并借助国泰君安证券与其商业伙伴的服务资源，为会员提供生活、娱乐、投资的全方位享受。</div>
    			</div>
    		</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	created(){
	  		//
	  	},
	}
</script>

<style lang="less" scoped>
	.us{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				height:340px;
				border-radius:10px;
				overflow:hidden;
				
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.usContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:10px;
					font-size:28px;
					color:#818181;
					letter-spacing:0;
					line-height:28px;
				}
				.abstract{
					margin-top:20px;
					font-size:24px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:40px;
				}
				.content{
					width:100%;
					margin-top:30px;
					.text-container{
						margin-bottom:40px;
						img{
							width:100%;
						}
						.text-title{
							margin-top:30px;
							font-size:28px;
							color:#ad8f5a;
							letter-spacing:0;
							line-height:64px;
						}
						.text-content{
							margin-top:10px;
							font-size:24px;
							color:#666666;
							letter-spacing:0.08px;
							line-height:52px;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/us.vue